module.exports = __webpack_public_path__ + "static/media/table.34c2351f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/table.png
// module id = 138
// module chunks = 0